import { useEffect } from "react";
import { Link } from "react-router-dom";
import { SEOHead } from "@/components/SEOHead";
import Lenis from "@studio-freight/lenis";

const PrivacyPage = () => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smooth: true, smoothTouch: false });
    const raf = (time) => { lenis.raf(time); requestAnimationFrame(raf); };
    requestAnimationFrame(raf);
    window.scrollTo(0, 0);
    return () => lenis.destroy();
  }, []);

  return (
    <div className="min-h-screen bg-black" data-testid="privacy-page">
      <SEOHead
        title="Política de Privacidad | Disruptiva"
        description="Política de Privacidad de Disruptiva. Conoce cómo recopilamos, usamos y protegemos tus datos personales."
        path="/politica-de-privacidad"
      />
      <div className="max-w-3xl mx-auto px-6 pt-32 pb-24">
        <Link to="/" className="text-white/30 hover:text-white/60 text-sm font-space transition-colors">← Inicio</Link>
        <h1 className="font-space font-bold text-3xl md:text-4xl text-white mt-8 mb-12">Política de Privacidad</h1>
        <div className="legal-content">
          <p>Última actualización: 31 de marzo de 2026</p>
          <p>En <strong>Disruptiva</strong> ("nosotros", "nuestro" o "la empresa"), nos comprometemos a proteger la privacidad de nuestros usuarios y clientes. Esta Política de Privacidad explica cómo recopilamos, usamos, almacenamos y protegemos tu información personal cuando visitas nuestro sitio web <strong>www.disruptiva.online</strong> o utilizas nuestros servicios.</p>

          <h2>1. Información que recopilamos</h2>
          <h3>1.1 Información proporcionada directamente</h3>
          <ul>
            <li><strong>Datos de contacto:</strong> Nombre, correo electrónico, número de teléfono y empresa cuando completas el formulario de contacto o diagnóstico.</li>
            <li><strong>Mensajes:</strong> El contenido de las conversaciones con nuestro asistente virtual (chatbot) y mensajes enviados por WhatsApp.</li>
            <li><strong>Información de negocio:</strong> Datos sobre tu empresa, sector, tamaño y necesidades de comunicación proporcionados durante el proceso de diagnóstico.</li>
          </ul>

          <h3>1.2 Información recopilada automáticamente</h3>
          <ul>
            <li><strong>Datos de navegación:</strong> Dirección IP, tipo de navegador, sistema operativo, páginas visitadas, tiempo de permanencia y fuente de referencia.</li>
            <li><strong>Cookies:</strong> Utilizamos cookies esenciales para el funcionamiento del sitio y cookies analíticas para mejorar la experiencia del usuario.</li>
          </ul>

          <h2>2. Uso de la información</h2>
          <p>Utilizamos tu información personal para:</p>
          <ul>
            <li>Responder a tus consultas y solicitudes de servicio.</li>
            <li>Generar diagnósticos y propuestas personalizadas de comunicación estratégica.</li>
            <li>Enviar información relevante sobre nuestros servicios (solo con tu consentimiento previo).</li>
            <li>Mejorar nuestro sitio web y la experiencia del usuario.</li>
            <li>Cumplir con obligaciones legales y regulatorias.</li>
          </ul>

          <h2>3. WhatsApp y comunicaciones</h2>
          <p>Al contactarnos por WhatsApp o proporcionar tu número de teléfono:</p>
          <ul>
            <li>Tu número se utiliza exclusivamente para comunicación directa relacionada con los servicios solicitados.</li>
            <li>No compartimos tu número de teléfono con terceros para fines de marketing.</li>
            <li>Las conversaciones por WhatsApp están protegidas por el cifrado de extremo a extremo de la plataforma.</li>
            <li>Puedes solicitar la eliminación de tus datos de contacto en cualquier momento.</li>
          </ul>

          <h2>4. Chatbot e Inteligencia Artificial</h2>
          <p>Nuestro asistente virtual utiliza inteligencia artificial para responder consultas. Los datos del chat:</p>
          <ul>
            <li>Se procesan de forma anónima para mejorar el servicio.</li>
            <li>No se utilizan para entrenar modelos de IA de terceros.</li>
            <li>Se almacenan temporalmente durante la sesión y se eliminan periódicamente.</li>
          </ul>

          <h2>5. Compartición de datos con terceros</h2>
          <p>No vendemos, alquilamos ni compartimos tu información personal con terceros, excepto:</p>
          <ul>
            <li>Proveedores de servicios tecnológicos necesarios para el funcionamiento del sitio (hosting, analíticas).</li>
            <li>Cuando sea requerido por ley o autoridad competente.</li>
            <li>Con tu consentimiento explícito previo.</li>
          </ul>

          <h2>6. Seguridad de los datos</h2>
          <p>Implementamos medidas de seguridad técnicas y organizativas para proteger tu información, incluyendo cifrado de datos en tránsito (HTTPS), acceso restringido y copias de seguridad periódicas.</p>

          <h2>7. Tus derechos</h2>
          <p>Tienes derecho a:</p>
          <ul>
            <li>Acceder a los datos personales que tenemos sobre ti.</li>
            <li>Solicitar la corrección de datos inexactos.</li>
            <li>Solicitar la eliminación de tus datos personales.</li>
            <li>Retirar tu consentimiento en cualquier momento.</li>
            <li>Presentar una queja ante la autoridad de protección de datos correspondiente.</li>
          </ul>

          <h2>8. Contacto</h2>
          <p>Para cualquier consulta sobre esta Política de Privacidad o para ejercer tus derechos, contáctanos:</p>
          <ul>
            <li>Correo: informacion@disruptiva.online</li>
            <li>Teléfono: +503 6433 0431</li>
            <li>WhatsApp: +503 6433 0431</li>
          </ul>

          <h2>9. Modificaciones</h2>
          <p>Nos reservamos el derecho de modificar esta Política de Privacidad en cualquier momento. Los cambios serán publicados en esta página con la fecha de actualización correspondiente.</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
